import React from 'react';
import { useTheme } from '../context/ThemeContext';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...', size = 'md' }) => {
  const theme = useTheme();
  const spinnerSize = size === 'sm' ? '1.5rem' : '2rem';
  const borderWidth = size === 'sm' ? '0.125rem' : '0.25rem';

  return (
    <div style={{ textAlign: 'center', padding: size === 'sm' ? '2rem 0' : '5rem 0' }}>
      <div
        style={{
          width: spinnerSize,
          height: spinnerSize,
          border: `${borderWidth} solid #e5e7eb`,
          borderTop: `${borderWidth} solid #8b5cf6`,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }}
      />
      <p style={{ fontSize: '0.875rem', color: theme.textMuted ?? '#6b7280' }}>{message}</p>
    </div>
  );
};

export default LoadingSpinner;
